<template>
  <div>
    <div class="content">
      <van-tabs
        v-model="active"
        line-height="2px"
        color="#45B9BC"
        sticky
        :swipe-threshold="6"
        title-active-color="#45B9BC"
        @click="change_active()"
      >
        <van-tab v-for="(tabItem,tabIndex) in tabList" :key="tabIndex">
          <!--标签标题栏-->
          <div slot="title">{{tabItem.title}}</div>

          <!--订单为空-->
          <div
            class="order__emptyBox"
            v-if="!tabItem.orderList || tabItem.orderList[0] == undefined"
          >
            <img src="/static/img/order_empty.png" alt />
            <p>暂无订单，快去逛逛吧~</p>
          </div>

          <div v-else>
            <!--订单内容-->
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="order__listBox"
                v-for="(orderItem,orderIndex) in tabItem.orderList"
                :key="orderIndex"
              >
                <div v-if="orderItem">
                  <router-link  :to="{ path: '/orderDetails', query: {'orderid':orderItem.id}}" class="order__list" :key="orderIndex">
                    <div class="order__list_title flex">
                      <span>{{ orderItem && orderItem.store_name ? orderItem.store_name : ""}}</span>
                      <span class="col_45B9BC" v-if="orderItem.status == 0">待付款</span>
                      <span class="col_45B9BC" v-if="orderItem.status == 1">待接单</span>
                      <span class="col_45B9BC" v-if="orderItem.status == 2">待服务</span>
                      <span class="col_45B9BC" v-if="orderItem.status == 3">已完成</span>
                      <span class="col_45B9BC" v-if="orderItem.status == 4">已拒绝</span>
                      <span class="col_45B9BC" v-if="orderItem.status == -1">已关闭</span>
                    </div>
                    <div class="order__list_content">
                      <div class="flex">
                        <span>{{ orderItem && orderItem.servicetitle ? orderItem.servicetitle : "" }}</span>
                        <span>¥{{orderItem.price}}</span>
                      </div>
                      <div class="fs_12 order__content_subtitle">
                        <p class="col_999">预约时间：{{orderItem.starttime}}</p>
                        <p  v-if="orderItem.status==2" class="col_45B9BC" >
                          <span>{{orderItem.distance_text}}</span><span>{{orderItem.surplustime}}</span>
                        </p>
                      </div>
                      <!-- 待付款订单-按钮-->
                      <div class="order__content_btnBox" v-if="orderItem.status==0">
                        <router-link :to="{path: '/orderDetails',query: {cancelrs_show:true,orderid:orderItem.id}}" v-if="orderItem.is_cancel==1">取消订单</router-link>
                        <router-link :to="{path: '/orderDetails',query: {orderid:orderItem.id}}" v-if="orderItem.is_pay==1" class="order__btn2">立即付款</router-link>
                      </div>
                      <!-- 待服务订单-按钮-->
                      <div class="order__content_btnBox" v-if="orderItem.status==2">
                        <router-link :to="{path: '/orderDetails',query: {cancelrs_show:true,orderid:orderItem.id}}" v-if="orderItem.is_cancel==1">取消订单</router-link>
                        <!-- <router-link to="/">修改订单</router-link> -->
                        <router-link :to="{path: '/checkservice',query: {orderid:orderItem.id}}" class="order__btn2">确认服务</router-link>
                      </div>
                      
                      <!-- 已完成订单-按钮-->
                      <div class="order__content_btnBox">
                        <!--退款按钮-->
                        <router-link :to="{path: '/orderDetails',query: {orderid:orderItem.id}}"  v-if="orderItem.status==3&&orderItem.is_refund==1"   class="order__btn2 refund">退款</router-link>

                        <router-link :to="{path:'/comment', query:{orderid:orderItem.id}}"  v-if="orderItem.status==3 && orderItem.is_comment != 1" class="order__btn2">待评价</router-link>
                                                
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!--底部固定导航-->
    <tab-bar :order-active="'active'" :order-icon="'/static/img/icon_nav44.png'"></tab-bar>
  </div>
</template>

<script>
import tabBar from "@/components/tabBar.vue";
export default {
  name: "order",
  components: { tabBar },
  data() {
    return {
      active: 99,
      loading: false,
      finished: false,
      key: 0,
      page:0,
      order_total:0,
      order_none:0,
      // 订单列表
      tabList: [
        {
          id: "0",
          title: "全部",
          // 加载更多
          // loading: false,
          // finished: true,
          orderList: []
        },
        {
          id: "1",
          title: "待付款",
          // 加载更多
          // loading: false,
          // finished: true,
          orderList: []
        },
        {
          id: "2",
          title: "待接单",
          // 加载更多
          // loading: false,
          // finished: true,
          orderList: []
        },
        {
          id: "3",
          title: "待服务",
          // 加载更多
          // loading: false,
          // finished: true,
          orderList: []
        },
        {
          id: "4",
          title: "已完成",
          // 加载更多
          // loading: false,
          // finished: true,
          orderList: []
        },
        {
          id: "5",
          title: "已取消",
          // 加载更多
          // loading: false,
          // finished: true,
          orderList: []
        }
      ]
    };
  },
  created() {
    if (this.$route.query.status == 0) {
      this.active = 1;
    }
    if (this.$route.query.status == 1) {
      this.active = 2;
    }
    if (this.$route.query.status == 2) {
      this.active = 3;
    }
    if (this.$route.query.status == 3) {
      this.active = 4;
    }
    if (this.$route.query.status == -1) {
      this.active = 5;
    }
    if (!this.active) {
      this.active = 99;
    }
    this.init();
  },
  methods: {
    init() {
      this.get_order();
    },
    get_order() {
      let status = 99;
      let active = this.active;
      if (this.active == 1) {
        status = 0;
      }
      if (this.active == 2) {
        status = 1;
      }
      if (this.active == 3) {
        status = 2;
      }
      if (this.active == 4) {
        status = 3;
      }
      if (this.active == 5) {
        status = -1;
      }
      if (this.active == 99) {
        status = 99;
        active = 0;
      }
      this.axios({
        url: this.api.order.get_member_order, 
        data: { status: status,page:this.page }
      }).then(res => {
        if (res.error === 0) {
          if (res.member_orders) {
            // this.tabList[active].orderList = res.member_orders;

            this.order_total = res.member_order_total;
            var that  = this;
            // console.log(res.member_orders.length);
            for(let i=0;i<res.member_orders.length;i++){
                that.tabList[active].orderList.push(res.member_orders[i]);
            }
            
            if(res.member_orders.length>0){
                that.order_none = 1
            }
             this.loading = false
            //  console.log( that.tabList[active].orderList.length);
            //  console.log(this.order_total);
            if ( that.tabList[active].orderList.length >= this.order_total) {
              // console.log("-------------");
              this.finished = true
            }
          }
        }
      });
    },
    change_active() {
      // this.get_order();
      this.change_order();
    },
    // 加载数据
    onLoad() {
       let active = this.active;
       if (this.active == 99) {
        active = 0;
      }
        // 异步更新数据
        setTimeout(() => {
          // 定义当前所在的数组
          var tabList_active=this.tabList[this.active];
          // 定义一个变量，取出当前数组的里的list
          var list=tabList_active['orderList'];
         this.loading  =false;
        //  console.log( list.length +"--------------"+this.order_total);
          // 加载状态结束
           if ( list.length >= this.order_total) {
             this.finished = true
          }else{
              this.page =this.page+1;         
             this.get_order();
          }

         
        }, 500);
      },
    change_order(){
          this.order_none=0; 
          this.page = 0;
          this.finished= false;
          this.loading = true;
          this.tabList[this.active].orderList= [];  
          this.get_order();
      },
  }
};
</script>

<style scoped>
@import "../../assets/css/order.css";
.refund{
      border-color: #c8c9cc!important;
    color: #7d7e80!important;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order.vue